export default __webpack_public_path__ + "static/media/formularios-navbar-icon.21e8ca6a.svg";